// import React from "react";
// // import OurRecruitersImage from "../../assets/trainingPlacement/MIBS- Our Recruters.jpg";
// import OurRecruitersImage from "../../assets/trainingPlacement/MIBS_OUR_RECRUTER.png";


// function OurRecruters() {
//   return (
//     <div>
//       <img src={OurRecruitersImage} alt="MIBS-our Recruiters" />
//     </div>
//   );
// }

// export default OurRecruters;

import React from "react";
import recruiters from "../../Data/Training&placement/OurRecruitersData";
import collegeLogo from "../../assets/trainingPlacement/college_our_rec_logo.png";
import "./OurRecruters.css";

const styles = {
  section: {
    display: "flex",
    alignItems: "stretch",
    background: "#ffffff",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
    flexWrap: "wrap",
    height: "85vh",
    maxHeight: "85vh",
    boxSizing: "border-box",
  },
  banner: {
    flex: "0 0 260px",
    background: "#c81e1e",
    clipPath: "polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    minWidth: "220px",
    boxSizing: "border-box",
  },
  bannerContent: {
    textAlign: "center",
  },
  crest: {
    width: "110px",
    marginBottom: "20px",
    filter: "drop-shadow(0 2px 6px rgba(0, 0, 0, 0.25))",
  },
  title: {
    color: "#fff",
    fontSize: "1.9rem",
    fontWeight: 800,
    lineHeight: 1.3,
    margin: 0,
  },
  gridWrapper: {
    flex: "1 1 0%",       // explicit basis of 0 forces flexbox to compute this from available space, not content
    height: "100%",       // redundant with flex:1, but guarantees a concrete height for overflow to key off of
    minHeight: 0,
    padding: "32px 16px 32px 24px",
    overflowY: "auto",
    minWidth: "280px",
    boxSizing: "border-box",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
    gap: "20px",
  },
  card: {
    background: "#fff",
    border: "1px solid #eee",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    minHeight: "90px",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  },
  logo: {
    maxWidth: "100%",
    maxHeight: "60px",
    width: "auto",
    height: "auto",
    objectFit: "contain",
  },
};

function OurRecruters() {
  return (
    <section style={styles.section}>
      <div style={styles.banner}>
        <div style={styles.bannerContent}>
          <img src={collegeLogo} alt="College Crest" style={styles.crest} />
          <h2 style={styles.title}>
            Our
            <br />
            Placement
            <br />
            Partners
          </h2>
        </div>
      </div>

      <div className="our-recruiters-scroll" style={styles.gridWrapper}>
        <div style={styles.grid}>
          {recruiters.map((company, index) => (
            <div
              key={index}
              style={styles.card}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow =
                  "0 6px 16px rgba(0, 0, 0, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <img src={company.logo} alt={company.name} style={styles.logo} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurRecruters;